import createCache from 'services/createCache';

export default createCache({
	areasMap: {
		map: null,
		areasLayer: null,
	},
});
